import { render, staticRenderFns } from "./Detail-Customer.vue?vue&type=template&id=0861bb0e"
import script from "./Detail-Customer.vue?vue&type=script&lang=js"
export * from "./Detail-Customer.vue?vue&type=script&lang=js"
import style0 from "./Detail-Customer.vue?vue&type=style&index=0&id=0861bb0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports